module.exports = __webpack_public_path__ + "media/images/mesicniky-5aa063ff6a8bb1fe671ada0532b0c37a.png";